// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { aiAssistantManifest } from './ai-assistant';
import { casesManifest } from './cases';
import { documentsManifest } from './documents';
import { knowledgeBaseManifest } from './knowledge-base';
import { recordLinksManifest } from './record-links';
import { tagsManifest } from './tags';

/** Група модулів «Основа» (Basic): 6 модулів. */
export const basicGroup: IModuleGroupManifest = {
  key: 'basic',
  category: 'Core',
  name: { en: 'Core', uk: 'Основа' },
  sort: 0,
  modules: [aiAssistantManifest, casesManifest, documentsManifest, knowledgeBaseManifest, recordLinksManifest, tagsManifest],
};
